<template>
    <div>
        shouye 
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/baseMsg/baseMsg.vue